export function fixedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16);
    }).replace(/%20/g, "+");
}

export function addCachebuster(uri, ts) {
    return uri + (uri.indexOf('?') >= 0 ? '&' : '?') + 'tld=' + (ts || Date.now());
}

export function safeFilename(filename) {
    return filename.replace(/\s+/g,'-').replace(/([^a-z0-9-_.]+)/gi, '').replace(/-+/g,'-');
}